import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { Navigate, useNavigate } from "react-router-dom"; //Outlet,
import Loading from "./components/admin/childComponents/appComponents/Loading";
const SecureAdmin = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL || BASE_URL + "";
  const navigate = useNavigate("");
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setloading] = useState(true);

  useEffect(() => {
    try {
      let datas = "?encryption[eq]=" + localStorage.getItem("encryption");
      axios.get(BASE_URL + "checkingifsecured" + datas).then((res) => {
        if (res?.data?.status === 200) {
          localStorage.setItem("admin_authority", res.data.admin_authority);
          localStorage.setItem("admin_type", res.data.admin_type);
          localStorage.setItem("admin_status", res.data.admin_status);
          localStorage.setItem("admin_passport", res.data.admin_passport);
          localStorage.setItem("admin_signature", res.data.admin_signature);
          localStorage.setItem("NumberType", res.data.fileNumber);
          localStorage.setItem("admin_id", res.data.admin_id);
          localStorage.setItem("auth_name", res.data.admin_name);

          setAuthenticated(true);
        } else if (res?.data?.status === 500) {
          swal("Oops!", res.data.message, "error");
        }
        setloading(false);
      });
    } catch (error) {
      localStorage.removeItem("admin_passport");
      localStorage.removeItem("auth_token");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("auth_name");
      localStorage.removeItem("admin_type");
      localStorage.removeItem("NumberType");
      localStorage.removeItem("debitGrandTotal");
      localStorage.removeItem("creditGrandTotal");
      localStorage.removeItem("admin_signature");
      localStorage.removeItem("newGrandTotal");
      localStorage.removeItem("grandTotal");
      localStorage.removeItem("admin_authority");
      localStorage.removeItem("admin_status");
      localStorage.removeItem("allGrandTotal");
      localStorage.removeItem("selectedSearch");
      localStorage.removeItem("encryption");
    }
    setAuthenticated(false);
  }, []);

  axios.interceptors.response.use(undefined, (error) => {
    if (error.response.status === 401) {
      swal(
        "Unauthorized Attempt! Logout!",
        error.response.data.message,
        "warning"
      );
      navigate("/login"); //redirect to the Login page
    } else if (error.response.status === 403) {
      //Access Denied
      swal("Forbedden!", error.response.data.message, "warning");
      navigate("/user/dashboard"); //redirect to the Dashboard page
    } else if (error.response.status === 404) {
      //Page not found
      swal("404 Error!", error.response.data.message, "warning");
      navigate("/user/dashboard"); //redirect to the Dashboard page
    }

    return Promise.reject(error);
  });

  if (loading) {
    // Loading, Processing Payment, Please Dont Interrupt
    return <Loading message01={"Loading..."} />;
  }
  return !authenticated && <Navigate to="/login" />;
  //return authenticated ? <Outlet /> : <Navigate to="/login" />;
  /**/
};

export default SecureAdmin;
